// Import style lib
import styled from 'styled-components';

// Import colors
import colors from '../../utils/styles/colors';

// Styled wrapper for the Header
export const HeaderWrapper = styled.header`
    /* Size */
    height: 70px;

    /* Element disposition */
    position: relative;
    flex-shrink: 0;

    /* Content disposition */
    display: flex;
    align-items: center;
    justify-content: space-between;

    /* Spacing */
    padding: 0px 15px;

    /* Visual effects */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.5);
`;

// Styled left section
export const LeftSection = styled.section`
    /* Content disposition */
    display: flex;
    align-items: center;
    gap: 10px;
`;

// Styled center section
export const CenterSection = styled.section`
    /* Element disposition */
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    /* Content disposition */
    display: flex;
    align-items: center;
`;

// Styled right section
export const RightSection = styled.section`
    /* Content disposition */
    display: flex;
    align-items: center;
    gap: 10px;
`;

// Styled logout button
export const LogoutButton = styled.button`
    /* Appearance */
    background-color: ${colors.primaryBeige};
    border-radius: 10px;

    /* Content disposition */
    display: flex;
    align-items: center;
    justify-content: center;

    /* Spacing */
    padding: 5px 10px;

    /* Visual effects */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.3);

    /* Events */
    cursor: pointer;
    &:hover {
        filter: brightness(1.2);
    }
`;

// Styled Logo
export const Logo = styled.img`
    /* Size */
    width: ${(props) => props.width}px;

    /* Events */
    cursor: pointer;
    &:hover {
        filter: brightness(1.2);
    }
`;
